import { ITEMS_REQUESTS_TYPES } from "redux/reducers/integrations/itemsRequestsTypes";
import { api_get, api_patch } from "services/api";
import { startRequest, stopRequest, setSnackbar } from "../search/searchActions";

const {
    GET_ITEMS_REQUESTS,
    FILTER_LIST_REQUESTS,
    SET_CONFIG_FILTERED_ITEMS_REQUESTS,
    SET_CONFIG_PAGE_ITEMS_REQUESTS,
    SET_CONFIG_PAGE_ITEMS_REQUESTS_COUNT,
    SET_CONFIG_SORTED_ITEMS_REQUESTS,
} = ITEMS_REQUESTS_TYPES

const url = `${process.env.REACT_APP_URL_INTEGRATIONS}/items_requests`;
const urlItems = `${process.env.REACT_APP_URL_INTEGRATIONS}/items`;
const qid = `KZDut9V3GRvS9KeD`;

export const getAllItemsRequests = (idUser = null, startDate = null) => {
    let getItemsRequestUrl = `${url}?qid=${qid}`;
    getItemsRequestUrl += idUser ? `&idUser=${idUser}` : ``
    getItemsRequestUrl += startDate ? `&fromDate=${startDate}` : ``

    return async (dispatch) => {
        dispatch(startRequest())
        await api_get(getItemsRequestUrl).then(resp => {
            dispatch({
                type: GET_ITEMS_REQUESTS,
                payload: resp
            })
            dispatch(stopRequest())
        }).catch(err => {
            dispatch(setSnackbar(err))
            dispatch(stopRequest())
        })
    }
}

export const modifyItems = (form) => {
    const getItemsUrl = `${urlItems}?qid=${qid}`;
    return async (dispatch) => {
        dispatch(startRequest())
        await api_patch(getItemsUrl, form).then(resp => {
            dispatch(setSnackbar("Actualizado correctamente", 'success'))
            dispatch(getAllItemsRequests())
            dispatch(stopRequest())
        }).catch(err => {
            dispatch(setSnackbar(err))
            dispatch(stopRequest())
        })
    }
}

export const submitApproval = (data, idItem) => {
    const getItemsRequestUrl = `${urlItems}/${idItem}/approve-or-reject?qid=${qid}`;
    return async (dispatch) => {
        dispatch(startRequest())
        await api_patch(getItemsRequestUrl, data).then(resp => {

            dispatch(setSnackbar(resp?.message, resp?.status === "FAILED" ? 'warning' : 'success'))

            dispatch(getAllItemsRequests())
            dispatch(stopRequest())
        }).catch(err => {
            dispatch(setSnackbar(err))
            dispatch(stopRequest())
        })
    }
}

export const savePriceIndividual = (price, idItem, idStation) => {
    const getItemsUrl = `${urlItems}/station-price/${idItem}/${idStation}?qid=${qid}`;
    return async (dispatch) => {
        dispatch(startRequest())
        await api_patch(getItemsUrl, price).then(resp => {
            dispatch(setSnackbar(resp?.message ? resp?.message : "Actualizado correctamente", 'success'))
            dispatch(getAllItemsRequests())
            dispatch(stopRequest())
        }).catch(err => {
            dispatch(setSnackbar(err))
            dispatch(stopRequest())
        })
    }
}

export const filtersItemsRequests = (status) => {
    return { type: FILTER_LIST_REQUESTS, payload: status }
}


export const configPageItemsRequests = (page) => {
    return { type: SET_CONFIG_PAGE_ITEMS_REQUESTS, payload: page }
}


export const configPageItemsRequestsSize = (page) => {
    return {
        type: SET_CONFIG_PAGE_ITEMS_REQUESTS_COUNT,
        payload: page
    }
}
export const configFilterItemsRequests = (filter) => {
    return { type: SET_CONFIG_FILTERED_ITEMS_REQUESTS, payload: filter }
}


export const configSortedItemsRequests = (sorted) => {
    return { type: SET_CONFIG_SORTED_ITEMS_REQUESTS, payload: sorted }
}